import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { InvoiceModel } from '@domain-group/realhub-backend-api-types'

import { generateUrls } from '@hooks/useInvoice'

const generateTabBarItems = (invoice: InvoiceModel) => {
  const urls = generateUrls(invoice)
  const { editInvoiceUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editInvoiceUrl,
      key: 'details',
      title: invoice?.title || 'Invoice Details',
    },
  ]
}

export default generateTabBarItems
